import { Component, OnInit, ViewChild, Input } from '@angular/core';



import { ActivatedRoute, Router } from '@angular/router';
import { Site,Supervision, SupervisionStatusEnum } from 'solar-bo';
import { DbSupervOverviewComponent } from '../../dashboard/db-superv-overview/db-superv-overview.component';
import { SortHelper } from 'shtools';
import { SolarBaseComponent } from '@solar/solar/solar-base/solar-base.component';

@Component({
  selector: 'app-site-superv',
  templateUrl: './site-superv.component.html'
})
export class SiteSupervisionComponent extends SolarBaseComponent implements OnInit {


  @Input()site: Site;
  @Input()lastSupervion:boolean=true;
  @ViewChild('dashboard') dashboard: DbSupervOverviewComponent;
  @Input() supervision:Supervision;
  showMap=false;
  dashboardVisible=false;
  supervision1:Supervision=new Supervision();

  dbSupervOverview_options={showTitle:false,title:"Site Dashboard", titleSub: "Based on last supervision"};

  constructor(public route: ActivatedRoute) {
    super();
  }


  ngOnInit() {
    if (this.supervision){
      this.site=this.supervision.site;
      this.dashboardVisible = true;
      this.loading = false;
      this.showMap=true;
      return;
    }
    else{
      this.getList();
    }
    
  }

  getList(): void {
    if (!this.site){
      return;
    }
    this.loading = true;
    this.solarService.siteGetSupervisions(this.site.id)
      .subscribe(resList => this.handleresult(resList)
        , err => this.handleError(err)
      );

/*     let query="select * from supervision s where id_site ='"+ this.site.id +"' order by date desc limit 1";  

    this.solarService.aquery(query)
      .subscribe(resList => this.handleresult(resList)
        , err => this.handleError(err)
      ); */      
  }
  handleresult(resList: any) {
    this.loading = false;
    if (resList && resList.length>0){
      resList=SortHelper.sortMultiple(resList,["info.supervisionDate"],["desc"]);
      for (let item of resList){
        let superv:Supervision=item;
        if (superv.info.status==SupervisionStatusEnum.VALIDATED){
          this.supervision=superv;
          break;
        }
      } 
      if (this.supervision)    {
        if (!this.dashboardVisible) {
          this.dashboardVisible = true;
        }
        this.showMap=true;        
      } else{
        this.showmessage("There is no supervision available. If there is a supervision in progress when it is validated it will appear here.")
      }

    }

    this.loading = false;
  }
  refresh() {
    this.getList();
  }
}
